import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';

const styles = StyleSheet.create({
  root: {
    position: 'relative',
    zIndex: -1
  },
  homeIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: 12,
    background: 'black',
    ':hover': {
      background: COLORS.kgGreen
    }
  },
  homeIcon: {
    fontSize: 14,
    color: 'white'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/map-markers/home-location-marker-styles.js